/**
 * The two-step reveal (ADR 002 §5 W3): put a registration's wine under a
 * letter, reveal the wine, then reveal who brought it. Plus "Glenn 7/8".
 */
import type { RevealBringerInput, ScoringProgressRow } from '@gwc/shared';
import { api } from '../lib/api';
import type { WineRow } from './models';

type WineResult = { data: { wine: WineRow } };

export const revealApi = {
  /** Bag a registration's wine under this letter, or clear it with null. */
  assign: (eventId: string, wineId: string, registrationId: string | null) =>
    api
      .post<WineResult>(`/events/${eventId}/wines/${wineId}/assign`, { registrationId })
      .then((r) => r.data.wine),
  /** Step 1 — the wine. `registrationId` assigns first. */
  revealWine: (eventId: string, wineId: string, registrationId?: string) =>
    api
      .post<WineResult>(
        `/events/${eventId}/wines/${wineId}/reveal`,
        registrationId ? { registrationId } : {},
      )
      .then((r) => r.data.wine),
  /** Step 2 — who brought it. */
  revealBringer: (eventId: string, wineId: string, body: RevealBringerInput = {}) =>
    api
      .post<WineResult>(`/events/${eventId}/wines/${wineId}/reveal-bringer`, body)
      .then((r) => r.data.wine),
  /** Undo step 2 (a mis-tap). */
  hideBringer: (eventId: string, wineId: string) =>
    api
      .del<WineResult>(`/events/${eventId}/wines/${wineId}/reveal-bringer`)
      .then((r) => r.data.wine),
  scoringProgress: (eventId: string) =>
    api
      .get<{ data: ScoringProgressRow[] }>(`/events/${eventId}/scoring-progress`)
      .then((r) => r.data),
};
